<template>
    <div class="serial-box edit-sensitive-container" :class="{'box-like': boxLike, 'cannot-edit': !canEdit}"
         tabindex="-1">
        <div class="search-result-container more-dropdown-button-container" tabindex="-1" ref="container"
             v-if="showingSerialResult||showingEmptyIndicator||showingErrorIndicator||searchingSerial">
            <div class="inner-content">
                <template v-if="showingSerialResult">
                    <header class="search-result-container-header d-flex align-items-center">
                        <span class="header-text">
                            <slot name="headerText">
                                Serial {{serialObject['serial_id']}}
                            </slot>
                        </span>
                        <div class="header-tools">
                            <slot name="headerTools"></slot>
                        </div>
                        <simple-dropdown class="more-dropdown-button ml-auto mr-1"
                                         v-if="inEditWorkMode && canEdit">
                            <template v-slot:dropdownMenu>
                                <ul>
                                    <li>
                                        <button @click="deleteSerial(serialObject['serial_id'])">
                                            <span>Delete Serial</span>
                                        </button>
                                    </li>
                                </ul>
                            </template>
                        </simple-dropdown>
                    </header>
                    <serial-describer :serial-object="serialObject"
                                      :parent-document-object="parentDocumentObject"></serial-describer>
                </template>
                <template v-if="showingEmptyIndicator">
                    <header class="search-result-container-header">Invalid Serial ID "{{serialId}}".
                        Please try another!
                    </header>
                </template>
                <template v-if="showingErrorIndicator">
                    <header class="search-result-container-header">There was something not right. Please try
                        again!
                    </header>
                </template>
                <template v-if="searchingSerial">
                    <header class="search-result-container-header">Loading</header>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import SimpleDropdown from "@/components/SimpleDropdown";
    import SerialDescriber from "@/components/SerialDescriber";
    import {userSettingsManager, workModeEdit} from "@/utils";
    import {getSerialBasicAndBoundDocuments} from "@/apis";

    export default {
        name: "SerialBox",
        components: {SerialDescriber, SimpleDropdown},
        props: {
            parentDocumentObject: Object,
            canEdit: Boolean,
            serialId: String,
            boxLike: {
                default: true,
            }
        },
        methods: {
            setStates(searchingSerial, showingEmptyIndicator, showingErrorIndicator, showingSerialResult) {
                this.searchingSerial = searchingSerial;
                this.showingEmptyIndicator = showingEmptyIndicator;
                this.showingErrorIndicator = showingErrorIndicator;
                this.showingSerialResult = showingSerialResult;
            },
            deleteSerial() {
                this.eventHub.$emit('attemptToDeleteSerialFor' + this.parentDocumentObject['global_document_id'], this.serialId)
            },
            findSerial() {
                if (!this.serialId) {
                    this.setStates(false, false, false, false);
                    return;
                }

                const searchRequestId = ++this.searchRequestId;

                if (this.lastSerialId !== this.serialId) {
                    this.setStates(true, false, false, false);
                }

                this.lastSerialId = this.serialId;

                getSerialBasicAndBoundDocuments(this.serialId).then(r => {
                    if (searchRequestId !== this.searchRequestId) {
                        return
                    }

                    if (r.data) {
                        this.serialObject = r.data;
                        this.setStates(false, false, false, true);
                    } else {
                        this.serialObject = null;
                        this.setStates(false, true, false, false);
                    }
                }).catch((err) => {
                    if (searchRequestId !== this.searchRequestId) {
                        return
                    }

                    this.setStates(false, false, true, false);

                    this.handleServerSideError(err);
                });


            },
            focus() {
                this.$refs.container.focus();
            },
        },
        data() {
            return {
                searchingSerial: false,
                showingEmptyIndicator: false,
                showingErrorIndicator: false,
                showingSerialResult: false,
                serialObject: null,
                searchRequestId: 0,
                lastSerialId: null,
            }
        },
        computed: {
            workMode() {
                return userSettingsManager.getWorkMode();
            },
            inEditWorkMode() {
                return this.workMode === workModeEdit;
            },
        },
        watch: {
            serialId: {
                handler() {
                    this.findSerial();
                },
                immediate: true,
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/variables";

    .box-like {
        .search-result-container {
            padding: 0.5rem;
            background-color: rgba(black, 0.02);
            border: 2px solid rgba(black, 0.05);
            border-radius: 2px;

            &:focus {
                box-shadow: 0 0 4px -1px rgba($primary-blue, 0.5);
            }
        }
    }

    .search-result-container {
        outline: none;

        .search-result-container-header {
            display: flex;
            align-items: center;

            &:not(:last-child) {
                margin-bottom: 0.75rem;
            }

            .header-text {
                font-size: 1.15em;
                font-weight: 500;
            }

            .more-dropdown-button {
                cursor: pointer;
            }

            .header-tools {
                margin-left: auto;
            }
        }
    }
</style>
